import { WarningIcon } from "../../../../assets/icons";
import { getVendorNature } from "../../../LoanApplicationSteps/VendorInformation/utils";
import { LoanProductType } from "../../../../hooks/api/types";

interface RejectedVendorsSectionProps {
  loanType: LoanProductType;
}

const RejectedVendorsSection = ({ loanType }: RejectedVendorsSectionProps) => {
  const vendorNature = getVendorNature(loanType);

  return (
    <div className="cx-bg-white cx-rounded-lg cx-w-full cx-shadow-md cx-p-10 cx-mb-6 cx-flex cx-flex-col cx-justify-center cx-items-center cx-h-56">
      <WarningIcon className={"cx-w-12 cx-h-12"} />
      <div className={"cx-font-bold cx-text-xl cx-mb-2"}>
        Rejected {vendorNature}
      </div>
      <div
        className={
          "cx-text-text-secondary cx-font-normal cx-text-base cx-text-center"
        }
      >
        All the {vendorNature}s you added have not been approved. All the{" "}
        {vendorNature}s have failed AML.
        <br />
        Please add new {vendorNature}s in order to proceed with your
        application.
      </div>
    </div>
  );
};

export default RejectedVendorsSection;
